import React from 'react';
import SkeletonBlock from '../SkeletonBlock';
import { ListRowSkeletonStack } from '../ListRowSkeleton';
import TableSkeleton from '../TableSkeleton';
import FormSkeleton from '../FormSkeleton';
import { CardStackSkeleton } from '../PortalShellSkeleton';

/**
 * Default page-level skeleton. Use layout-specific skeletons (table, calendar)
 * when a page already has a matching shape; otherwise this covers the gap.
 */
export default function PageSkeleton({
  variant = 'page',
  showHeader = true,
  fill = false,
  padded = false,
  rows,
  label = 'Loading',
  className = '',
}) {
  const body =
    variant === 'table' ? (
      <TableSkeleton rows={rows || 8} label={label} />
    ) : variant === 'form' ? (
      <FormSkeleton
        fields={rows || 6}
        showAvatar={showHeader}
        label={label}
      />
    ) : variant === 'cards' ? (
      <CardStackSkeleton cards={rows || 4} label={label} />
    ) : (
      <ListRowSkeletonStack rows={rows || 8} variant="compact" label={label} />
    );

  const hostClass = [
    'sk-host',
    'sk-page',
    fill ? 'sk-page--fill' : '',
    padded ? 'sk-page--padded' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={hostClass} role="status" aria-busy="true" aria-label={label}>
      {showHeader && variant !== 'form' ? (
        <div className="sk-page__header">
          <SkeletonBlock width="28%" height={22} />
          <SkeletonBlock width="44%" height={12} />
        </div>
      ) : null}
      {body}
    </div>
  );
}
